import { render } from "./Purchase_Order_Details.vue?vue&type=template&id=0089f67f"
import script from "./Purchase_Order_Details.vue?vue&type=script&lang=js"
export * from "./Purchase_Order_Details.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__